import React from 'react';

import { useForm } from 'react-hook-form';

import { LbInput } from '@infoods/lifebase-ui';

import classes from './SetUpPinCodeModal.module.scss';
import { entityInbodyPinCodeStore } from '../../../../stores/entityInbodyPinCodeStore';
import { LbModal } from '../../../../../shared/components/modals';
import { patterns } from '../../../../../shared/constants/patterns';

type PinCodeFormValue = {
  pin: string;
  confirmPin: string;
};

type SetUpPinCodeModalProps = {
  open: boolean;
  onClose: () => void;
};

const SetUpPinCodeModal = ({ open, onClose }: SetUpPinCodeModalProps) => {
  const { control, handleSubmit } = useForm<PinCodeFormValue>({
    shouldUnregister: true,
  });

  const handleFormSubmit = handleSubmit(async (data) => {
    await entityInbodyPinCodeStore.upsertPin(data.pin);
    onClose();
  });

  const handleClose = () => {
    onClose();
  };

  return (
    <LbModal
      open={open}
      title="Set up PIN"
      text="Enter the same code you used when you locked the InBody Machine."
      primaryBtnConfig={{ text: 'Save', onClick: handleFormSubmit }}
      secondaryBtnConfig={{ text: 'Cancel', onClick: handleClose }}
    >
      <form noValidate className={classes.form}>
        <LbInput
          control={control}
          label="New PIN"
          name="pin"
          rules={{
            required: 'New PIN is required',
            pattern: {
              value: patterns.FOUR_DIGIT_NUMBER,
              message: 'The PIN must be a 4-digit number',
            },
          }}
        />
        <LbInput
          control={control}
          label="Confirm New PIN"
          name="confirmPin"
          rules={{
            required: 'Please confirm your PIN',
            validate: (confirmPin, formValue) =>
              confirmPin === formValue.pin || 'PINs do not match',
          }}
        />
      </form>
    </LbModal>
  );
};

export { SetUpPinCodeModal };
